import { FaCheck } from "react-icons/fa";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { GetPackegeList } from "../../api/get";
import Header from "../../Common/Header";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import { useNavigate } from "react-router-dom";
import { handleApiError } from "../../Common/Helper";
const SubscriptionComp = () => {
  // const [Subscription, setSubscription] = useState(0);
  const [Package, setPackage] = useState(0);
  const [packageList, setPackegeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [partnerEmail, setPartnerEmail] = useState("");
  const [error, setError] = useState(null);
  useEffect(() => {
    handleApiCall();
  }, []);
  const handleApiCall = () => {
    GetPackegeList()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setPackegeList(res.data);
          // Check if partner_detail has at least one entry
          const partnerEmail =
            res.data.partner_detail?.[0]?.beneficiary_email || "";
          setPartnerEmail(partnerEmail);
        } else {
          handleApiError(res,navigate);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("An error occurred");
        console.log(err);
      });
  };
  const handleContinue = () => {
    if (validatePartnerEmail()) {
      // Determine the value of partnerEmail based on the Package
      const emailToPass = Package === 1 ? null : partnerEmail;
      const selectedPackage = {
        ...packageList["packages"][Package],
        partnerEmail: emailToPass,
      };
      console.log("++++ selectedPackage", selectedPackage);
      navigate("/make-will-online/subscription/options", { state: { selectedPackage } });
    }
  };
  const validatePartnerEmail = () => {
    if (
      Package === 0 &&
      (!partnerEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(partnerEmail))
    ) {
      setError("Please enter a valid partner email address.");
      return false;
    }
    setError(null);
    return true;
  };
  // console.log("Package =>", Package);
  // console.log("packageList =>",packageList?.packages)
  // console.log("error =>",error)
  // console.log("partnerEmail =>", partnerEmail);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <Toaster />
          <div className="bg-primary w-full h-screen">
            <div className="container">
              <div className="grid grid-cols-2 max-md:grid-cols-1 text-black ">
                  <div className="bg-[#fff] h-auto p-5">
                    <div className="mx-5">
                      <p className="font-bold text-[22px] md:text-[26px] sm:text-[22px] lg:text-[28px]">
                        I would like a will...
                      </p>
                    </div>
                    {packageList?.packages?.map((item, index) => {
                      return (
                        <div
                          key={item.id || index}
                          className="flex items-start gap-2 py-4 mx-5"
                        >
                          <input
                            id={`Post-check-${index}`} // Unique ID for each radio button
                            onChange={() => {
                              setPackage(index);
                              setError(null); // Reset error when package is changed
                            }}
                            checked={Package === index}
                            type="radio"
                            name="Post-check"
                            className="w-4 h-4 mt-1 text-[#240642] bg-gray-100 border-gray-300 rounded-full dark:focus:ring-[#240642] dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <div>
                            <label htmlFor={`Post-check-${index}`}>
                              <p className="font-bold">{item.package_name}</p>
                            </label>

                            {index === 0 ? (
                              Package === 0 ? (
                                <>
                                  <p className="pt-3 text-slate-500 text-[16px]">
                                    Two wills: one for you and one for your
                                    partner. We’ll send your partner an email to
                                    complete their will after payment.
                                  </p>
                                  <div className="pt-5">
                                    <p className="flex items-center gap-4">
                                      <FaCheck /> A legally binding will for
                                      each of you
                                    </p>
                                    <p className="flex items-center gap-4">
                                      <FaCheck /> Both wills registered
                                    </p>
                                    <p className="flex items-center gap-4">
                                      <FaCheck /> Both wills checked by experts
                                    </p>
                                  </div>
                                  <div className="w-full mt-5">
                                    <FloatingLabelInput
                                      label="Partner's email address"
                                      type="text"
                                      id="partner_email"
                                      name="partner_email"
                                      value={partnerEmail}
                                      onChange={(e) => {
                                        setPartnerEmail(e.target.value);
                                        setError(null);
                                      }}
                                      error={error}
                                    />
                                  </div>
                                </>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                            {index == 1 ? (
                              Package === 1 ? (
                                <div className="pt-5">
                                  <p className="flex items-center gap-4 py-1">
                                    <FaCheck /> One legally binding will
                                  </p>
                                  <p className="flex items-center gap-4 py-1">
                                    <FaCheck /> National will registration
                                  </p>
                                  <p className="flex items-center gap-4 py-1">
                                    <FaCheck /> Checked by experts
                                  </p>
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      );
                    })}

                    <div className="m-5">
                      <button
                        className="border-2 w-full rounded-[5px] bg-primary text-white border-[#240642] text-[#240642] px-4 py-3 font-bold"
                        onClick={handleContinue}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                <div className="max-lg:hidden">
                  <div className="fixed bottom-[0px] w-[500px] right-[6%]  flex justify-center">
                    <img
                      src="/assets/images/1.png"
                      alt="wills-guru-logo-white"
                      className="h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SubscriptionComp;
